import notFound from './notFound';

export default {
  ...notFound,
};
